import { getApiClient } from '@src/services/api-client'
import { useMutation } from '@tanstack/react-query'
import { makeGetCsv } from '../make-api'

const newsletterSubscriptionExportApi = makeGetCsv('/NewsletterSubscription/export')

async function downloadNewsletterSubscriptionsExport() {
  const apiClient = getApiClient()
  return newsletterSubscriptionExportApi(apiClient)
}

export function useNewsletterSubscriptionsExport() {
  return useMutation({
    mutationFn: downloadNewsletterSubscriptionsExport,
  })
}
